module.exports = __webpack_public_path__ + "static/media/Slide2-web.6e01e83f.jpg";